;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

const getGroup = gql`
  query getGroup($id: Int!) {
    group(id: $id) {
      active
      publicId
      allowWaitlist
      approvedForPromotion
      cohorts {
        nodes {
          acceptedCount
          config
          groupId
          id
          joinableWhileRunning
          location
          locationVirtual
          maxSize
          minSize
          pendingCount
          schedule
          seatsRemaining
          status
          latestPricing {
            id
            priceType
            priceValue
            refundPolicyHours
            refundPolicyPercent
          }
          name
        }
        totalCount
      }
      currentPublicationRequest {
        id
        approved
        active
        reason
      }
      config
      description
      descriptionSections
      groupTags {
        nodes {
          tagId
          id
          tag {
            category
            description
            value
          }
        }
      }
      id
      city
      consultRequired
      expectationDescription
      joinableWhileRunning
      latitude
      licensedCapacity
      location
      locationSetting
      locationVirtual
      longitude
      maxSize
      minSize
      name
      newsletterBlurb
      newsletterEnabled
      organizationId
      peopleDescription
      priceType
      priceValue
      recruitingPhase
      refundPolicyHours
      refundPolicyPercent
      requiredResidentStates
      state
      youDescription
      zipCode
      photoUrl
      primaryProviderId
      primaryProvider {
        userId
        user {
          preferredName
          preferredFirstName
          preferredLastName
          firstName
          lastName
        }
      }
      providerContent
      published
      publishedAt
      status
      type
      createdAt
      updatedAt
    }
  }
`
export default getGroup
